import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IDateInputBehavior } from "../../../../documaker/domain/format/objects";

export interface IDateInputBehaviorPropertyEditable {
  dateInputBehavior(): IPropertyEditable<IDateInputBehavior>;
}

export function instanceOfIDateInputBehaviorPropertyEditable(instance: any): instance is IDateInputBehaviorPropertyEditable {
  return instance
      && instance.dateInputBehavior
      && instanceOfIPropertyEditable<IDateInputBehavior>(instance.dateInputBehavior());
}
